const PromocodeModel = {};

PromocodeModel.TYPE = {
  PERCENT: {
    id: 1,
    title: 'Percent',
  },
  FIXED: {
    id: 2,
    title: 'Fixed',
  },
};

PromocodeModel.TitleToIdMap = {
  PERCENT_DISCOUNT: 1,
  FIXED_DISCOUNT: 2,
};

PromocodeModel.idToTitleMap = {
  [PromocodeModel.TYPE.PERCENT.id]: 'Percent discount',
  [PromocodeModel.TYPE.FIXED.id]: 'Fixed discount',
};

PromocodeModel.TYPE_LIST = [
  PromocodeModel.TYPE.PERCENT,
  PromocodeModel.TYPE.FIXED,
];

PromocodeModel.entity = {
  api: 'promocodes',
  state: 'promocodes',
};

export default PromocodeModel;
